import React from "react";

function Highlights(service) {
  return (
    <>
      <div className="service2-section mb-50">
        <div className="container">
              <div className="section-title2 primary3 text-start" data-aos="fade-up">
                <span>{service.service.highlist_title}</span>
                  <h2>{service.service.sub_title}</h2>
          </div>
          <div className="row justify-content-center g-4">
            {
              service.service.services_list && service.service.services_list.length &&
              service.service.services_list.map((service, index) => {
                return (
                  <div key={service.title} className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-item2 glass-effect" data-aos="fade-up" >
                      <div className="service-icon-wrap">
                        {
                          service.icon_image && service.icon_image.length &&
                          <img
                            src={service.icon_image}
                            className="service-icon img-fluid"
                            alt="service21"
                          />
                        }
                      </div>
                      <div className="service-content">
                        {/* <span>{index + 1}</span> */}
                        <span className="mb-0"><h4 className="mb-0">{service.title}</h4></span>
                        <p className="para">
                          {service.short_description}
                        </p>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default Highlights;
